import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { postRsvpAmendPlan, validateRsvpAmendPlan } from '../../../../../../../global/ducks/benadmin-api';
import { PensionPlanTypes } from '../../../plan-history/plan-history-models';
import { LayDcPlanAdoptionContentModel, LayDcPlanFormModel, PlanSubmitRequest } from '../../models/plan-adoption-form-models';
import { IPlanSubmitRequest, IQccoStatusDto } from '../../models/plan-adoption-requests';
import { GetAmendRsvpFormContentModel } from '../plan-amend-helper';
import { RsvpReviewWizard } from './rsvp-review-wizard';

export class RsvpAmendReviewWizard extends RsvpReviewWizard {

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendRsvpFormContentModel(content, institutionSettings);
        const requiresIndemnification = this.isIndemnificationRequired();

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.RsvpAmendReview,
            docuSignSubject: institutionSettings?.amendRSVPDocuSignSubject,
            docuSignFinishText: institutionSettings?.amendRSVPDocusignFinishText,
            docuSignTemplateId: requiresIndemnification ? institutionSettings?.amendIndemnifyRSVPDocuSignTemplateId : institutionSettings?.amendRSVPDocuSignTemplateId,
        };
    }

    createSubmitModel(formValue: LayDcPlanFormModel): IPlanSubmitRequest {
        const adoptRequest: IPlanSubmitRequest = super.createSubmitModel(formValue);
        const qcco_status: IQccoStatusDto = adoptRequest?.qcco_status;
        const rsvpPlan = adoptRequest?.rsvp_plan;
        const latestAmendmentAttributes = rsvpPlan?.latest_amendment_attributes;
        const amendmentDate = formValue?.adoption_date;        

        const request: IPlanSubmitRequest = {
            rsvp_amendment: {
                ...latestAmendmentAttributes,
                plan_id: formValue?.planId,
                amendment_date: amendmentDate,
                docusign_envelope_id: rsvpPlan?.docusign_envelope_id,
                contribution_overrides: rsvpPlan?.contribution_overrides,
            },
            qcco_status,
        };

        return request;
    }

    onSuccessQueryParams() {        
        return `?formType=${this.wizardOptions?.formType}&form=${PensionPlanTypes.Rsvp}&isamend=true`;
    }

    onValidateRequest(request: PlanSubmitRequest, onValidationSucess?: (request: PlanSubmitRequest) => void, onFailure?: () => any) {

        const formValues = request?.values as LayDcPlanFormModel;
        const payload = this.createSubmitModel(formValues);
        const planIdString = formValues?.planId?.toString();

        this.dispatch(validateRsvpAmendPlan(
            request?.clientId,
            planIdString,
            payload,
            () => onValidationSucess(request),
            onFailure),
        );
    }

    onSubmit(request: PlanSubmitRequest) {

        const formValues = request?.values as LayDcPlanFormModel;
        const payload = this.createSubmitModel(request?.values as LayDcPlanFormModel);
        const planIdString = formValues?.planId?.toString();

        this.dispatch(postRsvpAmendPlan(request?.clientId, planIdString, payload, () => this.onSuccess(request)));
    }
}